var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.75H15.5v-.875a.875.875 0 10-1.75 0v.875h-3.5v-.875a.875.875 0 10-1.75 0v.875H6.75A1.75 1.75 0 005 8.5v8.75c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0019 17.25V8.5a1.75 1.75 0 00-1.75-1.75zm0 10.5H6.75V9.812h10.5v7.438z"
  })));
}

export default SvgCalendar;